// extracted by mini-css-extract-plugin
module.exports = {"carousel-wrapper":"styles__carousel-wrapper___umRuL","label":"styles__label___1nTnr"};